module.exports = __webpack_public_path__ + "static/media/create-device-page.db796354.png";